import { render, staticRenderFns } from "./select-head.vue?vue&type=template&id=e22052e4&"
import script from "./select-head.vue?vue&type=script&lang=js&"
export * from "./select-head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e22052e4')) {
      api.createRecord('e22052e4', component.options)
    } else {
      api.reload('e22052e4', component.options)
    }
    module.hot.accept("./select-head.vue?vue&type=template&id=e22052e4&", function () {
      api.rerender('e22052e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/select-head.vue"
export default component.exports